import Http from 'services/utils/http';
import CacheStore from 'services/utils/cacheStore';
import SingletonService from 'services/utils/singletonService';
import { parseParamsForURL } from 'services/utils/urlParams';

const apiName = 'countries';

class CountriesService {
    baseUrl = '/partners/utils/countries.json';

    cache = CacheStore.getStore(apiName);

    clearData() {
        this.cache.commit({
            type: 'clearCache',
            api: apiName
        });
    }

    // eslint-disable-next-line class-methods-use-this
    formatData(data) {
        const res = [];
        const values = Object.values(data.countries);
        for (let i = 0; i < values.length; i++) {
            // eslint-disable-next-line no-restricted-syntax
            for (const code in values[i]) {
                // eslint-disable-next-line no-prototype-builtins
                if (values[i].hasOwnProperty(code)) {
                    res.push({
                        id: code,
                        flag: code,
                        title: values[i][code],
                        displayText: values[i][code]
                    });
                }
            }
        }
        res.sort((a, b) => {
            if (a.title < b.title) { return -1; }
            if (a.title > b.title) { return 1; }
            return 0;
        });

        return res;
    }

    async get({
        filters = {
            removeSanctionedCountries: true
        }
    } = {}) {
        const params = parseParamsForURL(filters);
        return Http.get(`${this.baseUrl}?${params}`, false).then((resData) => {
            const res = this.formatData(resData.data);
            this.cache.commit({
                type: 'setCache',
                api: apiName,
                data: res
            });
            return res;
        });
    }
}

const singletonService = new SingletonService(apiName);
if (!singletonService.isInitialized()) {
    singletonService.setService(new CountriesService());
}

export default singletonService.getService();
